import * as React from 'react';
import { SearchbarProps, SearchbarBuilder } from '@components/form/searchbar';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Dispatch } from 'redux';
import { SearchUsers } from '@webapp/store/user/action-creators';

import { UserSearchResult } from '../../../types/user-search-result';
import { Avatar } from '@components/basics/avatar';
import SimpleUser from '@common/types/user/simple-user';
import Flag from '@components/basics/flag';

export interface UsersSearchCtrlProps extends SearchbarProps<UserSearchResult> {
  currentValues: SimpleUser[];
  search: (value: string) => SearchUsers;
  leftDecoration?: React.ReactNode;
}

export const getUserHelpText = (user: SimpleUser) => {
  const parts: string[] = [];

  const hideEmail = (email: string) => {
    return email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, '$1***@$2');
  };

  if (user.email) {
    const email = hideEmail(user.email);
    parts.push(email);
  }

  // if (user.telephone) {
  //   parts.push(user.telephone);
  // }

  return parts.join(', ');
};

const mapStateToProps = (state: AppState) => {
  let results: UserSearchResult[] = [];

  results = results.concat(
    state.user.search.users.map((user) => ({
      id: user.id,
      type: 'user',
      avatar: user.avatar,
      country: user.country?.id,
      helpText: getUserHelpText(user),
      name: user.fullName || user.email || user.telephone || user.username,
      contact: (user.email || user.telephone) as string,
    }))
  );

  results = results.concat(
    state.user.search.invites.map((invite) => ({
      id: `${invite.name}${invite.email_or_phone}`,
      type: 'invite',
      name: invite.name as string,
      contact: invite.email_or_phone as string,
      helpText: '',
    }))
  );

  results = results.filter((r) => !!(r.name && r.contact));

  return {
    results,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  search: (value: string) => dispatch(new SearchUsers(value)),
});

const Searchbar = SearchbarBuilder<UserSearchResult>();

export const UsersSearchCtrl: React.FC<UsersSearchCtrlProps> = (props) => {
  const filterResult = (value: UserSearchResult) => {
    if (!(value.name || value.contact)) {
      return false;
    }

    if (!props.currentValues) {
      return true;
    }

    return !props.currentValues.find(
      (a) =>
        a.id === value.id ||
        a.fullName.toLowerCase().trim() === value.name.toLowerCase().trim()
    );
  };

  return (
    <Searchbar
      {...props}
      valueMapper={(value) => (value.name || value.contact) as string}
      filterList={filterResult}
      resultMapper={(value) => value.name}
      keyMapper={(value) => value.id}
      decorationMapper={(value) =>
        value.avatar ? <Avatar src={value.avatar} /> : <Avatar />
      }
      rightDecorationMapper={(value) =>
        value.country ? <Flag countryCode={value.country} squareFlag /> : null
      }
      helpTextMapper={(value) => value.helpText}
      leftDecoration={props.leftDecoration}
      dropdownListPadding="20px 0"
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersSearchCtrl);
